import gql from 'graphql-tag'

export const generateAcordForm = gql`
  mutation($input: AcordFormInput!) {
    newAcordForm(
      input: $input
    )
  }
`

export const getAcordFormTemplates = gql`
  query($type: String!, $query: String!) {
    getAcordFormTemplates(
      type: $type,
      query: $query
    ) {
      id
      templateFileName
    }
  }
`
